if (!customElements.get('featured-collection-tab')) {
  class FeaturedCollectionTab extends HTMLElement {
    constructor() {
      super();
  
      this.groupNameItems.forEach(item => {
        item.addEventListener('click', this.onGroupNameClick.bind(this));
      })
      this.init()
    }
  
    get collectionGroups() {
      return Array.from(this.querySelectorAll('.collection-group'));
    }

    get groupList() {
      return this.querySelector('.collection-group__list');
    }
  
    get groupNameItems() {
      return Array.from(this.querySelectorAll('.collection-group__list-item'));
    }
  
    get activeGroupNameItem() {
      return this.querySelector('.collection-group__list-item.is-active');
    }
  
    // 读一个正整数 data-* 属性，缺失/非法时回退到 fallback。
    // 这样即使某个 section 还是旧版 liquid（没输出这些属性），行为也和改动前一致。
    readInt(name, fallback) {
      const raw = this.dataset[name];
      if (raw === undefined || raw === null || raw === '') return fallback;
      const n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 0 ? n : fallback;
    }

    init() {
      theme.ContainerDraggable(this.groupList)
      // 间距、平板/手机档的每页数量都改为从 liquid 传来的 data-* 读取，
      // 运营在主题编辑器里就能调。回退值 = 改动前写死的那几个数：
      //   gap 原来固定 16（线上现状）
      //   perTablet 原来固定 2、perMobile 原来固定 1
      const gap = this.readInt('gap', 16)
      const perTablet = this.readInt('perTablet', 2)
      const perMobile = this.readInt('perMobile', 1)
      // 手机端独立间距：0 / 缺失 = 不单独设，整段逻辑跳过，行为与改动前完全一致。
      // splide 的 mediaQuery:'min' 下断点按 min-width 生效、后面的覆盖前面的，
      // 所以 0 档给手机值、768 档再改回电脑值，断点与 CSS 的 768 保持一致。
      const gapMobile = this.readInt('gapM', 0)
      const options = {
        perPage: 1,
        gap: gap,
        padding: 0,
        arrows: false,
        pagination: true
      }
  
      if (this.dataset.autoplay) {
        options.type = 'loop'
        options.autoplay = true
        options.interval = parseInt(this.dataset.autoplay) * 1000
      }
  
      for (const groupEl of this.collectionGroups) {
        const groupOpt = Object.assign({}, options)
        if (groupEl.dataset.cardType == 'small') {
          groupOpt.mediaQuery = 'min'
          groupOpt.breakpoints = {
            "0": {
              perPage: perMobile
            },
            "600": { 
              perPage: perTablet
            },
            "960": {
              perPage: parseInt(groupEl.dataset.columns)
            }
          }
        }
        if (gapMobile > 0) {
          groupOpt.mediaQuery = 'min'
          const bp = Object.assign({}, groupOpt.breakpoints)
          bp['0'] = Object.assign({}, bp['0'], { gap: gapMobile })
          bp['768'] = Object.assign({}, bp['768'], { gap: gap })
          groupOpt.breakpoints = bp
        }
        if (groupEl.querySelectorAll('.splide__slide').length <= 1) {
          groupOpt.type = 'slide'
          groupOpt.pagination = false
          groupOpt.arrows = false
        }
        new Splide(groupEl.querySelector('.splide'), groupOpt).mount()
      }
  
      if (this.groupNameItems.length > 0) {
        const firstGroupItem = this.querySelector('.collection-group__list-item:first-child')
        // const firstGroup = this.querySelector('.collection-group:first-child')
        // firstGroup.classList.add('is-active')
        // firstGroup.style.pointerEvents = "auto"
        // firstGroup.style.opacity = "1"
        this.switchGroup(firstGroupItem)
      }
    }
    
  
    onGroupNameClick(e) {
      this.switchGroup(e.target)
    }
  
    switchGroup(newActiveGroupName) {
      const oldActiveGroupName = this.activeGroupNameItem
      if (oldActiveGroupName) {
        if (newActiveGroupName.dataset.groupId == oldActiveGroupName.dataset.groupId) {
          return
        }
        oldActiveGroupName?.classList.remove('is-active')
      }
  
      newActiveGroupName.classList.add('is-active')
      const newActiveGroupContainer = this.querySelector(`.collection-group[data-group-id="${newActiveGroupName.dataset.groupId}"]`)
  
      // 隐藏新的分组产品
      if (oldActiveGroupName) {
        const oldActiveGroupContainer = this.querySelector(`.collection-group[data-group-id="${oldActiveGroupName.dataset.groupId}"]`)
        Motion.animate(oldActiveGroupContainer, {
          transform: "translateX(-40px)", 
          opacity: 0.5
        }, {duration: 0.2, easing: 'ease-in'}).finished.then(() => {
          Motion.animate(oldActiveGroupContainer, {
            transform: "translateX(0)", 
            opacity: 0
          }, {duration: 0.2, easing: 'ease-out'}).finished.then(() => {
            oldActiveGroupContainer.style.pointerEvents = "none"
            oldActiveGroupContainer.style.maxHeight = '100px'
            oldActiveGroupContainer.classList.remove('is-active')
          })
        })
      }
  
      // 显示新的分组产品
      Motion.animate(newActiveGroupContainer, {
        transform: "translateX(40px)", 
        opacity: 0.5
      }, {duration: 0.2, easing: 'ease-out'}).finished.then(() => {
        Motion.animate(newActiveGroupContainer, {
          transform: "translateX(0)", 
          opacity: 1
        }, {duration: 0.2, easing: 'ease-in'}).finished.then(() => {
          newActiveGroupContainer.style.pointerEvents = "auto"
          newActiveGroupContainer.style.maxHeight = "none"
          newActiveGroupContainer.classList.add('is-active')
        })
      })
    }
  }
  customElements.define('featured-collection-tab', FeaturedCollectionTab);
}